import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../../Context/AppProvider';
import DisplayName from './DisplayName';
import DisplayAvatar from './DisplayAvatar';

RoomItem.propTypes = {
      id: PropTypes.string,
      description: PropTypes.string,
      photoURLs:PropTypes.array,
      name: PropTypes.array,
      room:PropTypes.array,
};
RoomItem.defaultProps={
      id:'',
      description:'',
      photoURLs:[],
      name:[],
      room:[]
}

function RoomItem(props) {
      const {id, name, description, room, photoURLs} = props;
      const {setSelectedRoomId} = useContext(AppContext);
      const handleSelectedRoom=(id)=>{
            setSelectedRoomId(id);
            document.querySelector('.chat-window__wrapper').classList.add('chat-window__wrapper-show');
            document.querySelector('.side-bar').classList.add('side-bar-hide');
      }
      return (
            <li
                  onClick={() => handleSelectedRoom(id)}
            >
                  <div className="chat--list__item">
                        <div className="list__item--left">
                              <div className="chat--list__item--img">
                                    {
                                          photoURLs.map((value, index)=>(
                                                <DisplayAvatar
                                                      key={index}
                                                      photoURL={value}
                                                />
                                          ))
                                    }
                              </div>
                              <div className="chat--list__item--content">
                                    {
                                          name.map((value, index) => (
                                                <DisplayName
                                                      key={index}
                                                      displayName={value}
                                                />
                                          ))
                                    }
                                    <span className="item--content__desc">{description}</span>
                              </div>
                        </div>
                        <span className="list__item--right">{room.members.length} người</span>
                  </div>
            </li>
      );
}

export default RoomItem;